import React from "react";
import {useForm} from "react-hook-form";
import moment from "moment";


const ReservationExternalStep2 = (props) => {
    const [termsAccepted, setTermsAccepted] = React.useState(false);
    const [gdprAccepted, setGdprAccepted] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handleSubmit = () => {
        if (!termsAccepted) {
            setError('Pro pokračování je nutné souhlasit s obchodními podmínkami.');
            return;
        }
        if (!gdprAccepted) {
            setError('Pro pokračování je nutné souhlasit se zpracováním osobních údajů.');
            return;
        }
        props.onSubmit();
    }

    return <>
        <h2 className={'h5 mt-3 text-uppercase'}>{window.translations.reservationExternal.reservation}</h2>
        <div className="row">
            <div className={'col-md-12 mt-2'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold mb-3'}>
                        {window.translations.reservationExternal.items}:
                    </div>
                    <div className={'dotted-line mb-2'}>
                        <div>
                            {props.itemTitle}
                        </div>
                        <div>
                            {props.itemPrice} {window.translations.czk}
                        </div>
                    </div>
                    {props.selectedItems && props.selectedItems.map((item) => {
                        return <div className={'dotted-line mb-2'} key={item.id}>
                            <div>
                                {item.product.title}
                            </div>
                            <div>
                                {item.totalPriceFormatted}
                            </div>
                        </div>
                    })}
                    {props.selectedServices && props.selectedServices.map((service) => {
                        return <div className={'dotted-line mb-2'} key={service.id}>
                            <div>
                                {service.name}
                            </div>
                            <div>
                                {service.price} {window.translations.czk}
                            </div>
                        </div>
                    })}
                </div>
                {props.pricingNote &&
                    <div className={'text-end small text-black mb-3 me-2 mt-2 me-2'}>
                        {props.pricingNote}
                    </div>}
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        {window.translations.reservationExternal.from}:
                    </div>
                    <div>
                        {moment(props.dateFrom).format('DD.MM.YYYY')}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        {window.translations.reservationExternal.to}:
                    </div>
                    <div>
                        {moment(props.dateTo).format('DD.MM.YYYY')}
                    </div>
                </div>
            </div>
        </div>
        <h2 className={'h5 mt-3 text-uppercase'}>{window.translations.reservationExternal.steps.personalInfo}</h2>
        <div className="row">
            <div className={'col-md-6 mt-2'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        {window.translations.personalInfo.firstName}:
                    </div>
                    <div>
                        {props.personalData.firstname}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-2'}>
                <div className={'bg-light p-3'}>

                    <div className={'fw-bold'}>
                        {window.translations.personalInfo.lastName}:
                    </div>
                    <div>
                        {props.personalData.lastname}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        {window.translations.personalInfo.email}:
                    </div>
                    <div>
                        {props.personalData.email}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        {window.translations.personalInfo.phone}:
                    </div>
                    <div>
                        {props.personalData.phone}
                    </div>
                </div>
            </div>
            <div className={'col-md-6 mt-3'}>
                <div className={'bg-light p-3'}>
                    <div className={'fw-bold'}>
                        {window.translations.reservationExternal.wholeAddress}:
                    </div>
                    <div>
                        {props.personalData.address}, {props.personalData.zip} {props.personalData.city}
                    </div>
                </div>
            </div>
        </div>

        <div className={'row'}>
            <div className={'col-md-8 mt-3'}>
                <div className={'form-check mt-4'}>
                    <input className="form-check-input" type="checkbox" id="termsAccepted" value={termsAccepted}
                           onChange={(e) => setTermsAccepted(e.target.checked)}/>
                    <label className="form-check-label" htmlFor="termsAccepted">
                        Souhlasím s <a href={props.termsUrl} target={'_blank'}>obchodními podmínkami</a>.
                    </label>
                </div>
                <div className={'form-check mt-2'}>
                    <input className="form-check-input" type="checkbox" id="gdprAccepted" value={gdprAccepted}
                           onChange={(e) => setGdprAccepted(e.target.checked)}/>
                    <label className="form-check-label" htmlFor="gdprAccepted">
                        Souhlasím se <a href={props.gdprUrl} target={'_blank'}>zpracováním osobních údajů</a>.
                    </label>
                </div>
            </div>
            <div className={'col-md-4 mt-3 text-md-end'}>
                <div className={'pt-3 fs-5'}>
                    {window.translations.reservationExternal.totalPrice} {props.totalPrice} {window.translations.czk}
                </div>
            </div>
        </div>

        {error && <div className="alert alert-danger mt-3" role="alert">{error}</div>}

        <div className={'d-flex justify-content-between mt-4'}>
            <span className={'btn btn-light px-4 py-2 rounded-0 me-3'} onClick={() => props.setStep(props.hasExtras ? 2 : 1)}><i
                className="fas fa-chevron-left me-3"></i> {window.translations.reservationExternal.back}</span>
            {props.submitting ? <span className={'btn btn-primary px-4 py-2 rounded-0 disabled'}>
                <i className="fas fa-spinner fa-spin me-3"></i> {window.translations.reservationExternal.submitting}</span> :
            <span className={'btn btn-primary px-4 py-2 rounded-0'} onClick={handleSubmit}>{window.translations.reservationExternal.submit}
                <i className="fas fa-check ms-3"></i></span>}
        </div>
    </>;

};

export default ReservationExternalStep2;